/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *  ╔═○─┐ emotive
 *    ●●  ENGINE - Step Up Gesture
 *  └─○═╝
 * ═══════════════════════════════════════════════════════════════════════════════════════
 *
 * Quick weight shift upward (1 beat)
 */

import { createStepGesture } from './danceSteps.js';

export default createStepGesture('up');
